import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'form-error',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './form-error.component.html',
    styleUrl: './form-error.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorComponent {
    text = input.required<string>();
}
